__webpack_require__.p = "/static/en-IT/infographics/eni-for-2022/";